module.exports = __webpack_public_path__ + "img/btn-20-backup.aaa5c8c4.png";